import { GetRecruiterMeta, GetRecruiterPayload } from 'types/store/GetRecruiters';
import { createAsyncReducer } from 'utils/Redux';

import { getRecruiterActions } from '../actions';

export default createAsyncReducer<GetRecruiterMeta, GetRecruiterPayload>(getRecruiterActions);
